import { stringify } from 'qs';
import { createResource, RouterContext } from 'react-resource-router';

import { NavigationData } from 'src/types/navigation';
import { urls } from 'src/urls/repositories';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export type RepositoryNavigation = NavigationData & {
  repository: BB.Repository;
};

export const fetchRepoNavigationData = async (
  repositoryFullSlug: string,
  includeLandingPage = true
): Promise<RepositoryNavigation | null> => {
  const url = urls.api.internal.navigation(repositoryFullSlug);
  // TODO once we start using this for actual navigation data, include menuItems below
  const query = includeLandingPage
    ? stringify({
        fields: `+repository.landing_page`,
      })
    : '';
  const response = await fetch(
    authRequest(`${url}?${query}`, { headers: jsonHeaders })
  );

  if (!response.ok) {
    throw new Error(
      `Error fetching repository navigation data (${response.status}): ${response.statusText}`
    );
  }

  return response.json();
};

export const repositoryNavigationResource = createResource({
  type: 'REPOSITORY_NAVIGATION',
  getKey: ({ match }: RouterContext) => {
    if (match.params.repositoryFullSlug) {
      return `repository:${match.params.repositoryFullSlug}`;
    } else {
      return `repository:${match.params.repositoryOwner}/${match.params.repositorySlug}`;
    }
  },
  maxAge: 1000 * 60 * 10, // 10 minute
  getData: ({ match }): Promise<RepositoryNavigation | null> => {
    const { repositoryFullSlug, repositoryOwner, repositorySlug } =
      match.params;
    const repo = repositoryFullSlug ?? `${repositoryOwner}/${repositorySlug}`;
    return fetchRepoNavigationData(repo);
  },
});
